<template>
  <el-form
    class="ghost-button-styles"
    :model="targetingForm"
    label-width="180px"
    ref="formRef"
    :rules="makeTargetingRules.call({ targetingForm })"
  >
    <el-form-item label="定向包名称" prop="name">
      <el-input v-model="targetingForm.name" style="width: 320px"></el-input>
    </el-form-item>

    <el-form-item label="描述">
      <el-input style="width: 320px" type="textarea" v-model="targetingForm.description"></el-input>
    </el-form-item>

    <el-form-item label="账号选择">
      <el-select
        v-model="targetingForm.account"
        :popper-append-to-body="false"
        value-key="id"
        filterable
        style="width: 320px"
        @change="onAccountChange"
      >
        <el-option v-for="account in accountList" :key="account.id" :label="account.name" :value="account"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="投放场景">
      <el-radio-group v-model="targetingForm.ad_marketing_scene" @change="onAdMarketingSceneChange">
        <el-radio-button ghost :label="AD_MARKETING_SCENE.VERSION_3"> 腾讯3.0 </el-radio-button>
        <el-radio-button ghost :label="AD_MARKETING_SCENE.VERSION_SMART"> 腾讯-智投 </el-radio-button>
        <el-radio-button ghost :label="AD_MARKETING_SCENE.VERSION_SEARCH"> 搜索 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="手动定向模式" v-if="adMarketingSceneType.version3">
      <el-switch v-model="targetingForm.smart_targeting_mode"></el-switch>
      <span style="margin-left: 8px; font-size: 12px; color: #909399">{{ targetingForm.smart_targeting_mode ? '手动定向已开启，当前为手动定向模式' : '手动定向已关闭，当前为智能定向模式' }}</span>
    </el-form-item>

    <!-- 搜索广告定向参数 ----------------------------------------------------------- -->
    <template v-if="adMarketingSceneType.version_search">
      <el-form-item label="计划形式">
        <el-radio-group v-model="targetingForm.automatic_site_enabled">
          <el-radio-button ghost :label="false"> 手动版位 </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="计划版位" prop="siteSet">
        <el-checkbox-group v-model="targetingForm.siteSet">
          <el-checkbox-button ghost v-for="siteSet in SEARCH_AD_SITE_SET_LIST" :label="siteSet.label" :key="siteSet.label">
            {{ siteSet.name }}
          </el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="QQ浏览器等流量场景" v-if="targetingForm.siteSet.includes(SEARCH_AD_SITE_ENUM.QBSEARCH)">
        <el-radio-group v-model="targetingForm.qbsearch_scene">
          <el-radio-button ghost :label="0">不限</el-radio-button>
          <el-radio-button ghost :label="1">自定义</el-radio-button>
        </el-radio-group>

        <div v-if="targetingForm.qbsearch_scene === 1">
          <el-checkbox-group v-model="targetingForm.qbSearchScene">
            <el-checkbox :label="p.value" v-for="p in setSetInitData.qbSearchScenes" :key="p.value">{{ p.label }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

      <el-form-item label="微信搜一搜流量场景" v-if="targetingForm.siteSet.includes(SEARCH_AD_SITE_ENUM.WECHAT_SEARCH)">
        <el-radio-group v-model="targetingForm.wechat_search_scene">
          <el-radio-button ghost :label="0">不限</el-radio-button>
          <el-radio-button ghost :label="1">自定义</el-radio-button>
        </el-radio-group>

        <div v-if="targetingForm.wechat_search_scene === 1">
          <el-checkbox-group v-model="targetingForm.wechatSearchScene">
            <el-checkbox :label="p.value" v-for="p in setSetInitData.wechatSearchScenes" :key="p.value">{{ p.label }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

      <el-form-item label="关键词" prop="searchAdBidKeywords">
        <el-button :disabled="!targetingForm.account.id" @click="onSearchKeywordAdd">+添加关键词</el-button>
        <span>&emsp;已选{{ targetingForm.searchAdBidKeywords.length }}/1000</span>
      </el-form-item>
    </template>

    <!-- 3.0、智投定向参数---------------------------------------------------------- -->
    <template v-else>
      <el-form-item label="广告形式">
        <el-radio-group v-model="targetingForm.automatic_site_enabled" @change="onSiteSetTypeChange">
          <el-radio-button ghost :label="false" :disabled="targetingForm.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART">
            手动版位
          </el-radio-button>
          <el-radio-button ghost :label="true">自动版位</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="版位选择" prop="siteSet" v-if="!targetingForm.automatic_site_enabled">
        <el-checkbox-group v-model="targetingForm.siteSet" @change="onSiteSetItemChange">
          <el-checkbox-button ghost v-for="siteSet in SITE_SET_LIST" :label="siteSet.label" :key="siteSet.label">
            {{ siteSet.name }}
          </el-checkbox-button>
        </el-checkbox-group>
        <p style="font-size: 12px" v-if="targetingForm.siteSet.includes(SITE_ENUM.PCQQ)">【腾讯电脑端】流量当前仅用于“微信小游戏”投放</p>
      </el-form-item>

      <template v-if="targetingForm.automatic_site_enabled">
        <el-form-item label="探索策略">
          <el-radio-group v-model="targetingForm.exploration_strategy">
            <el-radio-button ghost :label="EXPLORATION_ENUM.AUTOMATIC">自动探索</el-radio-button>
            <el-radio-button ghost :label="EXPLORATION_ENUM.STEADY" :disabled="adMarketingSceneType.version_smart">
              稳步探索
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="优选版位" prop="priority_site_set" v-if="targetingForm.exploration_strategy === EXPLORATION_ENUM.STEADY">
          <el-checkbox-group v-model="targetingForm.priority_site_set">
            <el-checkbox-button ghost v-for="siteSet in SITE_SET_LIST" :label="siteSet.label" :key="siteSet.label">
              {{ siteSet.name }}
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </template>
    </template>

    <template v-if="targetingForm.siteSet.includes(SITE_ENUM.PCQQ)">
      <el-form-item label="腾讯电脑端定投">
        <el-radio-group v-model="targetingForm.pc_scene">
          <el-radio-button ghost :label="0">不限</el-radio-button>
          <el-radio-button ghost :label="1">自定义</el-radio-button>
        </el-radio-group>

        <div v-if="targetingForm.pc_scene === 1">
          <el-checkbox-group v-model="targetingForm.pcScene">
            <el-checkbox :label="p.value" v-for="p in setSetInitData.pcScenes" :key="p.value">{{ p.label }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </template>

    <!-- 只有手动版位包含微信公众号与小程序才显示 -->
    <!-- 20240319 增加自动版位显示 -->
    <!-- 20250530 新增智投广告与3.0广告显示问题 -->
    <template v-if="adMarketingSceneType.version3">
      <template v-if="targetingForm.siteSet.includes(SITE_ENUM.WECHAT) || targetingForm.automatic_site_enabled">
        <el-form-item label="微信公众号与小程序定投">
          <el-radio-group v-model="targetingForm.wechat_position">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div class="wechat-scene-spec wechat-positions-checkbox" v-if="targetingForm.wechat_position === 1">
            <el-checkbox-group v-model="targetingForm.wechatPostion">
              <el-checkbox :label="p.id" v-for="p in setSetInitData.wechatPositions" :key="p.id">{{ p.description }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>

        <el-form-item label="微信公众号与小程序场景">
          <el-radio-group v-model="targetingForm.wechat_scene">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div class="wechat-scene-spec wechat-scenes-checkbox" v-if="targetingForm.wechat_scene === 1">
            <div class="wechat-scenes-row official-account-cate">
              <div class="title">公众号媒体类型</div>
              <el-checkbox-group v-model="targetingForm.officialAccountMediaCate" @change="onOfficialAccountMediaCateChange">
                <el-checkbox :label="p.id" v-for="p in setSetInitData.officialAccountMediaCates" :key="p.id">{{
                  p.description
                }}</el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="wechat-scenes-row mini-game">
              <div class="title">
                <span>小程序小游戏流量类型</span>
                <el-popover
                  placement="top-start"
                  width="190"
                  trigger="hover"
                  content="场景对应定投投放位：小程序banner、小程序激励式、小程序插屏、小程序封面"
                >
                  <span class="el-icon-info" slot="reference"></span>
                </el-popover>
                <span v-show="showMiniGameTips" style="color: orange">&ensp;你未选择该流量场景对应定投的广告位，设置将不会生效</span>
              </div>
              <el-checkbox-group v-model="targetingForm.miniGame" @change="onMiniGameChange">
                <el-checkbox :label="p.id" v-for="p in setSetInitData.miniGames" :key="p.id">{{ p.description }}</el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="wechat-scenes-row pay-scene">
              <div class="title">
                <span>订单详情页消费场景</span>
                <el-popover placement="top-start" width="190" trigger="hover" content="场景对应定投投放位：微信支付订单详情页">
                  <span class="el-icon-info" slot="reference"></span>
                </el-popover>

                <span v-show="showPaySceneTips" style="color: orange">&ensp;你未选择该流量场景对应定投的投放位，设置将不会生效</span>
              </div>
              <el-checkbox-group v-model="targetingForm.payScene" @change="onPaySceneChange">
                <el-checkbox :label="p.id" v-for="p in setSetInitData.payScenes" :key="p.id">{{ p.description }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-form-item>
      </template>

      <!-- 只有手动版位包含微信视频号或自动版位才显示 -->
      <!-- 新增自动版位显示 -->
      <template v-if="showWechatChannels">
        <el-form-item label="微信视频号定投">
          <el-radio-group v-model="targetingForm.wechat_channels">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div class="wechat-scene-spec" v-if="targetingForm.wechat_channels === 1">
            <el-checkbox-group v-model="targetingForm.wechatChannels">
              <el-checkbox :label="p.id" v-for="p in setSetInitData.wechatChannelPositions" :key="p.id">{{ p.description }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
      </template>

      <template v-if="targetingForm.siteSet.includes(SITE_ENUM.MOBILE_UNION)">
        <el-form-item label="优量汇计划展示场景">
          <el-radio-group v-model="targetingForm.displaySceneType">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div style="margin-top: 6px" v-if="targetingForm.displaySceneType === 1">
            <el-checkbox-group v-model="targetingForm.scene_spec.display_scene">
              <el-checkbox-button v-for="item in DISPLAY_SCENE_LIST" :key="item.value" ghost :label="item.value">
                {{ item.label }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </el-form-item>

        <el-form-item label="优量汇自动流量优选">
          <el-switch v-model="targetingForm.flow_optimization_enabled"></el-switch>
        </el-form-item>

        <el-form-item label="优量汇流量包屏蔽" prop="exclude_union_position">
          <el-radio-group v-model="targetingForm.excludeUnionType" @change="onUnionPackageTypeChange">
            <el-radio-button ghost :label="0">不限</el-radio-button>
            <el-radio-button ghost :label="1">自定义</el-radio-button>
          </el-radio-group>

          <div v-if="targetingForm.account">
            <div
              class="exclude-union-selector"
              v-loading="unionPackageLoading"
              style="margin-top: 6px"
              v-if="targetingForm.excludeUnionType === 1"
            >
              <div class="accounts">
                <div class="header">账号</div>

                <div class="row-list">
                  <div
                    class="row-item"
                    :class="{ active: ac.id === currUnionPackageAccountId }"
                    v-for="ac in [targetingForm.account]"
                    :key="ac.id"
                    @click="onAccountItemChange(ac)"
                  >
                    <span>{{ ac.name }}</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>

              <CascaderSelector
                v-model="excludesUnionPositionPackages"
                filterable
                :max="5"
                :options="unionExcludePositionPackages"
                :props="{ multiple: true, value: 'id', label: 'value' }"
              ></CascaderSelector>
            </div>
          </div>
          <div v-else>请先选择账号</div>
        </el-form-item>
      </template>
    </template>

    <el-form-item label="地域" prop="regionType" v-if="adMarketingSceneType.version3">
      <el-radio-group v-model="targetingForm.regionType">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost :label="1">按省市</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 6px" v-if="targetingForm.regionType === 1">
        <CascaderSelector
          v-model="targetingForm.region"
          :options="filterdCityData"
          :props="{ multiple: true, value: 'id', label: 'value' }"
        ></CascaderSelector>

        <div>
          <el-checkbox-group v-model="targetingForm.locationTypes" :disabled="locationTypeDisabled">
            <el-checkbox label="RECENTLY_IN">近期在这里的人</el-checkbox>
            <el-checkbox label="LIVE_IN">常住这里的人</el-checkbox>
            <el-checkbox label="TRAVEL_IN">旅行到这里的人</el-checkbox>
            <el-checkbox label="VISITED_IN">去过这里的人</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </el-form-item>

    <el-form-item label="性别">
      <el-radio-group v-model="targetingForm.gender">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost label="MALE">男</el-radio-button>
        <el-radio-button ghost label="FEMALE">女</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="年龄">
      <el-radio-group v-model="targetingForm.age">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost :label="item.value" v-for="item in AGES" :key="item.label">{{ item.label }}</el-radio-button>
        <el-radio-button ghost :label="1">自定义</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 6px; width: 668px" v-if="targetingForm.age === 1">
        <p style="font-size: 12px">自定义年龄段：{{ ageRangeText }}</p>

        <!-- 当批量失败修改时，新建广告成功后不能再修改 -->
        <el-slider
          v-model="targetingForm.ageRange"
          :marks="{ 14: '14岁', 66: '66岁及以上' }"
          range
          show-stops
          :min="14"
          :max="66"
          :format-tooltip="(v) => (v === 66 ? '66岁及以上' : `${v}岁`)"
        >
        </el-slider>
      </div>
    </el-form-item>

    <el-form-item label="手机品牌" prop="deviceType" v-if="adMarketingSceneType.version3">
      <el-radio-group v-model="targetingForm.deviceType">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost :label="1">按手机品牌</el-radio-button>
      </el-radio-group>
      <div style="margin-top: 6px" v-if="targetingForm.deviceType === 1">
        <template v-if="targetingForm.account && targetingForm.account.id">
          <CascaderSelector
            v-model="targetingForm.device"
            :options="deviceBrandData"
            :props="{ multiple: true, value: 'id', label: 'value' }"
          ></CascaderSelector>
          <div>
            <el-checkbox v-model="targetingForm.excludeDevice">排除所选设备的用户</el-checkbox>
          </div>
        </template>
        <span v-else>请先选择账号</span>
      </div>
    </el-form-item>

    <el-form-item label="系统版本" prop="osType">
      <el-radio-group v-model="targetingForm.osType">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost :label="1">选择版本</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 6px" v-if="targetingForm.osType === 1">
        <CascaderSelector
          v-model="targetingForm.version"
          :options="deviceVersionData"
          :props="{ multiple: true, value: 'id', label: 'value' }"
        ></CascaderSelector>
      </div>
    </el-form-item>

    <template v-if="adMarketingSceneType.version_search || adMarketingSceneType.version_smart">
      <el-form-item label="微信再营销">
        <MixedElCheckBoxGroup v-model="targetingForm.wechatAdBehaviorType">
          <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
          <el-checkbox-button ghost label="ACTIONS">再营销</el-checkbox-button>
          <el-checkbox-button ghost label="EXCLUDED_ACTIONS">排除再营销</el-checkbox-button>
        </MixedElCheckBoxGroup>
        <WechatAdBehavior :behavior.sync="targetingForm.wechatAdBehavior" :type="targetingForm.wechatAdBehaviorType"></WechatAdBehavior>
      </el-form-item>
    </template>

    <template v-if="adMarketingSceneType.version3">
      <el-form-item label="网络">
        <MixedElCheckBoxGroup v-model="targetingForm.network">
          <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
          <el-checkbox-button ghost v-for="n in NETWORKS" :key="n.value" :label="n.label">{{ n.value }}</el-checkbox-button>
        </MixedElCheckBoxGroup>
      </el-form-item>

      <el-form-item label="游戏消费能力">
        <MixedElCheckBoxGroup v-model="targetingForm.game_consumption_level">
          <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
          <el-checkbox-button ghost label="HIGH">高</el-checkbox-button>
          <el-checkbox-button ghost label="NORMAL">普通</el-checkbox-button>
        </MixedElCheckBoxGroup>

        <!-- <el-radio-button ghost label="HIGH">高</el-radio-button>
        <el-radio-button ghost label="NORMAL">普通</el-radio-button> -->
      </el-form-item>

      <el-form-item label="微信再营销">
        <MixedElCheckBoxGroup v-model="targetingForm.wechatAdBehaviorType">
          <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
          <el-checkbox-button ghost label="ACTIONS">再营销</el-checkbox-button>
          <el-checkbox-button ghost label="EXCLUDED_ACTIONS">排除再营销</el-checkbox-button>
        </MixedElCheckBoxGroup>
        <WechatAdBehavior :behavior.sync="targetingForm.wechatAdBehavior" :type="targetingForm.wechatAdBehaviorType"></WechatAdBehavior>
      </el-form-item>

      <el-form-item label="设备价格">
        <MixedElCheckBoxGroup v-model="targetingForm.devicePrice">
          <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
          <el-checkbox-button ghost :label="price.value" v-for="price in DEVICE_PRICES" :key="price.value">
            {{ price.label }}
          </el-checkbox-button>
        </MixedElCheckBoxGroup>
      </el-form-item>
    </template>

    <el-form-item label="排除已转化用户">
      <el-radio-group v-model="targetingForm.excluded_converted_audience.excluded_dimension">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button v-for="item in EXCLUDED_CONVERSIONS_LIST" :key="item.value" ghost :label="item.value">
          {{ item.label }}
        </el-radio-button>
      </el-radio-group>

      <div class="custom-switch" v-if="targetingForm.excluded_converted_audience.excluded_dimension !== 0">
        <div class="switch">
          <el-switch v-model="targetingForm.excludeCustom"></el-switch>
          <span>&ensp;自定义转化行为</span>
        </div>
        <el-select
          v-if="targetingForm.excludeCustom"
          v-model="targetingForm.excluded_converted_audience.conversion_behavior_list"
          style="width: 280px; margin-top: 6px"
          multiple
          :popper-append-to-body="false"
          :multiple-limit="2"
          @change="onBehaviorChange"
        >
          <el-option v-for="item in CONVERSION_BEHAVIOR_LIST" :key="item.label" :value="item.value" :label="item.label"> </el-option>
        </el-select>

        <div v-if="targetingForm.excludeCustom">
          <div style="font-size: 13px">
            转化时间区间
            <el-tooltip
              class="item"
              effect="dark"
              content="设置排除已转化行为以及转化时间区间，计划不会曝光给所选范围内已转化的用户。系统将自动以当前计划选择的优化目标作为此定向的转化行为；该定向仅可选择oCPC、oCPM、oCPA 出价方式，若选择自定义转化行为则不限制出价方式。"
              placement="top-start"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <el-radio-group v-model="targetingForm.excluded_converted_audience.excluded_day">
            <el-radio-button ghost :label="EXCLUDED_DAY.ONE_DAY">当日</el-radio-button>
            <el-radio-button ghost :label="EXCLUDED_DAY.SEVEN_DAY">7日</el-radio-button>
            <el-radio-button ghost :label="EXCLUDED_DAY.ONE_MONTH">1个月</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </el-form-item>

    <!-- 关键词选择弹窗 -->
    <SearchBidKeywordSelectModal
      v-model="showSearchBidKeywordModal"
      :account-id="targetingForm.account.id"
      :list="searchBidKeywordList"
      :media-type="2"
      :filter-types="[{ label: '以词拓词', value: 1 }]"
      :patern-list="SEARCH_AD_BID_KEYWORD_PATERN"
      :site-sets="targetingForm.siteSet"
      @confirm="onSearchKeywordSelectConfirm"
    ></SearchBidKeywordSelectModal>
  </el-form>
</template>
<script setup>
import { nextTick, ref, computed } from 'vue'
import { Message } from 'view-design'
import MixedElCheckBoxGroup from '@/components/check-box-group/index.vue'
import WechatAdBehavior from '@/views/create/gdt/components/target/wechat-ad-behavior/index.vue'
import CascaderSelector from '@/components/cascader-select/index.vue'
import SearchBidKeywordSelectModal from '@/views/create/bytedance/components/project/components/search-bid.vue'
import {
  SITE_SET_LIST,
  SEARCH_AD_SITE_SET_LIST,
  SITE_ENUM,
  SEARCH_AD_SITE_ENUM,
  EXPLORATION_ENUM,
  WECHAT_SITES
} from '@/views/create/gdt/model/siteset/siteset-const.js'
import {
  AUDIENCES_TYPE,
  AGES,
  NETWORKS,
  DEVICE_PRICES,
  CONVERSION_BEHAVIOR_LIST,
  DISPLAY_SCENE_LIST,
  EXCLUDED_CONVERSIONS_LIST,
  EXCLUDED_DAY
} from '@/views/create/gdt/model/targeting-const.js'

import { AD_MARKETING_SCENE, SEARCH_AD_BID_KEYWORD_PATERN } from '@/views/create/gdt/model/project-const.js'

import { getAudience, getDevice } from '@/api/tencent.model'
import makeTargetingRules from '@/views/create/gdt/model/targeting-rules.js'

import {
  useInitialTargetingForm,
  useAccountList,
  useAudience,
  useAge,
  useRegion,
  useDevice,
  useDeviceOS,
  useExcludeConversion,
  useSiteSet,
  useGdtSearchBidKeywords
} from './useGdtv3TargetingForm.js'

const formRef = ref(null)
const { targetingForm } = useInitialTargetingForm()
const {
  showWechatChannels,
  unionPackageLoading,
  currUnionPackageAccountId,
  setSetInitData,
  excludesUnionPositionPackages,
  includesUnionPositionPackages,
  unionExcludePositionPackages,
  unionIncludePositionPackages,
  showMiniGameTips,
  showPaySceneTips,
  onPaySceneChange,
  onAccountItemChange,
  onSiteSetTypeChange,
  onAdMarketingSceneChange,
  onMiniGameChange,
  onSiteSetItemChange,
  onOfficialAccountMediaCateChange,
  onUnionPackageTypeChange,
  getSiteSetInitData
} = useSiteSet()
const { ageRangeText } = useAge()
const { filterdCityData, locationTypeDisabled } = useRegion()
const { deviceBrandData, getDeviceData } = useDevice()
const { deviceVersionData } = useDeviceOS()
const { onBehaviorChange } = useExcludeConversion()
// const { populations, audienceLoading, audiencesData, getAudienceData } = useAudience()
const { accountList, onAccountChange } = useAccountList({ getDeviceData })

const { showSearchBidKeywordModal, searchBidKeywordList, onSearchKeywordAdd, onSearchKeywordSelectConfirm } = useGdtSearchBidKeywords()

const adMarketingSceneType = computed(() => {
  const { ad_marketing_scene } = targetingForm.value
  return {
    version3: typeof ad_marketing_scene === 'undefined' || ad_marketing_scene === AD_MARKETING_SCENE.VERSION_3,
    version_smart: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART,
    version_search: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH
  }
})

// eslint-disable-next-line
defineExpose({
  validate: () => {
    const { searchAdBidKeywords } = targetingForm.value
    if (adMarketingSceneType.value.version_search && !searchAdBidKeywords?.length) {
      Message.warning('搜索计划关键词不能为空')
      return Promise.reject(new Error('搜索计划关键词不能为空'))
    }

    return formRef.value.validate()
  },
  getForm: () => targetingForm.value,
  setForm(form) {
    // if (form.account?.id) {
    //   getAudienceData(form.account.id)
    // }
    nextTick(() => {
      targetingForm.value = form

      const { account, includeUnionType, excludeUnionType, scene_spec } = form
      const excludesPackages = Object.values(scene_spec?.exclude_union_position_package || {})
      const includesPackages = Object.values(scene_spec?.include_union_position_package || {})

      // 如果修改时，存在账号，获取优量汇流量包列表
      if (account?.id) {
        if (includeUnionType === 1 || excludeUnionType === 1) {
          if (includesPackages.length || excludesPackages.length) {
            currUnionPackageAccountId.value = form.account.id
            onAccountItemChange(form.account)
          }
        }
      }
    })
  }
})
</script>
<style lang="scss" scoped>
.custom-switch {
  margin-top: 6px;

  .switch {
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
::v-deep .el-slider__marks-text {
  width: 40px;
  white-space: nowrap;
  font-size: 12px;
  margin-top: 6px;
}

.exclude-union-selector {
  display: flex;
  .accounts {
    min-width: 220px;
    border: 1px solid #dee4f5;
    border-radius: 4px;
    border-right: none;
    .header {
      background: #fafbfe;
      padding: 0 10px;
      border-bottom: 1px solid #dee4f5;
    }

    .row-list {
      height: 200px;
      overflow: auto;
      .row-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        cursor: pointer;
        font-size: 12px;
        margin-bottom: 0;

        > span {
          display: block;
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &:hover,
        &.active {
          background: #eee;
        }
      }
    }
  }

  .selector-box {
    flex: 1;
  }
}
</style>
